import { createAction } from 'redux-actions';

import { openFailedAlert } from 'actions/alert';
import { wrapFetch } from 'actions/endpoint';

import { pageChanging, pageChanged, loadingRatio } from './global';

export const getCommunity = createAction('FETCH_COMMUNITY', async (keyword = '', city) => {
	const params = keyword !== '' ? { keyword } : {};

	if (city) {
		params.city_id = city;
	}

	const { status, message, data } = await wrapFetch(
		'community',
		{
			method: 'GET',
		},
		params,
	);

	if (status !== 200) {
		throw openFailedAlert('generic', message);
	}

	const communityData = {};
	const list = data.data.map(item => {
		communityData[item.id] = item;

		return item.id;
	});

	return { currentPage: data.current_page, lastPage: data.last_page, list, data: communityData };
});

export const getMoreCommunity = createAction('FETCH_MORE_COMMUNITY', () => async (_, getState) => {
	const { community: { currentPage, search: { city, keyword } } } = getState();

	const params = keyword.value !== '' ? { keyword: keyword.value } : {};

	const [{ value: cityValue } = { value: null }] = city.value;

	if (cityValue) {
		params.city_id = cityValue;
	}

	const { status, message, data } = await wrapFetch(
		'community',
		{ method: 'GET' },
		{ page: currentPage + 1, ...params },
	);

	if (status !== 200) {
		throw openFailedAlert('generic', message);
	}

	const communityData = {};
	const list = data.data.map(item => {
		communityData[item.id] = item;

		return item.id;
	});

	return {
		list,
		data: communityData,
		currentPage: data.current_page,
		lastPage: data.last_page,
	};
});

export const getCommunityByKeyword = createAction(
	'FETCH_COMMUNITY_BY_KEYWORD',
	() => async (dispatch, getState) => {
		const { community: { search: { keyword, city } } } = getState();

		const [{ value } = { value: null }] = city.value;

		dispatch(pageChanging('FETCH_COMMUNITY_BY_KEYWORD'));
		dispatch(loadingRatio(0.8, 'FETCH_COMMUNITY_BY_KEYWORD'));

		await dispatch(getCommunity(keyword.value, value));

		dispatch(pageChanged('FETCH_COMMUNITY_BY_KEYWORD'));
	},
);

export const getCommunityCity = createAction('FETCH_COMMUNITY_CITY', async () => {
	const { status, message, data } = await wrapFetch('community/city', {
		method: 'GET',
	});

	if (status !== 200) {
		throw openFailedAlert('generic', message);
	}

	const cityData = {};
	const list = data.map(item => {
		cityData[item.id] = item;

		return item.id;
	});

	return { list, data: cityData };
});



// WEBPACK FOOTER //
// ./src/actions/community.js